import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import config from "../../config";
import { BookingApi, BookingSelectedServicesData, BookingStepName, NextStep } from "store/slices/bookingSlice";
import { useLocation, useNavigate } from "react-router";
import ApiStatus from "component/ApiStatus";
import BookingSteps from "./booking-service-steps";
import moment from "moment";
import CustomAlerts from "component/CustomAlerts";
import { OpenCustomAlerts } from "store/slices/commonSlice";
import BookingResourceModals from "../Booking/Form/bookServices/BookingResourceModal";
import NextAvailableBookingModal from "../Booking/Form/bookServices/BookingNextAvailableModal";
import { MoonLoader } from "react-spinners";
import { css } from "@emotion/react";
import { MinutesToHours } from "helpers/Functions";
import io from 'socket.io-client';

const removeChatWidgets = () => {
  const widgets = document.querySelectorAll('chat-widget');
  widgets.forEach(widget => widget.remove());
};

const OnlineBooking = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const isBookingApi = useSelector((state) => state.booking.isBookingApi);
  const isBookingStep = useSelector((state) => state.booking.isBookingStep);
  const bookingApiStatus = useSelector((state) => state.booking.isApiStatus);
  const isOpenCustomAlerts = useSelector((state) => state.common.isOpenCustomAlerts);
  const isBookingResourceModal = useSelector((state) => state.booking.isBookingResourceModal);
  const isBookingNextAvailableModal = useSelector((state) => state.booking.isBookingNextAvailableModal);
  const [processmsg, setprocessmsg] = useState('');

  useEffect(() => {
    // Remove chat widgets when the component mounts
    removeChatWidgets();

    // Set up a MutationObserver to detect and remove chat widgets if they are added dynamically
    const observer = new MutationObserver(() => {
      removeChatWidgets();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Cleanup observer on component unmount
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!document.body.classList.contains("online-booking-wrapper")) {
      document.body.classList.add("online-booking-wrapper");
    }
    dispatch(BookingApi(location)).then((action) => {
      if (action.meta.requestStatus === "fulfilled") {
        const bookingLinkData = action.payload;
        if (bookingLinkData) {
          const category = bookingLinkData?.category;
          const services = bookingLinkData?.services;
          const staff = bookingLinkData?.staff;

          const newCategoryValue = category?.name;
          const newServiceValue = services?.name;
          const newStaffValue = staff ? staff.first_name + ' ' + staff.last_name : "";
          const searchParams = new URLSearchParams(location.search);
          searchParams.set('category', newCategoryValue ? newCategoryValue : "");
          searchParams.set('service', newServiceValue ? newServiceValue : "");
          searchParams.set('staff', newStaffValue ? newStaffValue : "");
          const newSearch = `?${searchParams.toString()}`;
          const newURL = `${location.pathname}${newSearch}`;
          navigate(newURL)
          const serviceObjData = services;
          const staffObjData = staff;
          let staffservicesprice = serviceObjData && serviceObjData.staffservicesprice && serviceObjData.staffservicesprice;
          let gprice = staffservicesprice ? staffservicesprice.price : "0.00";
          // let add_on_price = staffservicesprice ? staffservicesprice.add_on_price : "0.00";
          // let totalprice = parseFloat(gprice) + parseFloat(add_on_price);
          let totalpricewithoutaddon = parseFloat(gprice);
          dispatch(BookingStepName("BookServices"));

          const duration = serviceObjData && serviceObjData.duration && serviceObjData.duration > 0 ? MinutesToHours(serviceObjData.duration) : "";
          const padding_time = serviceObjData && serviceObjData.padding_time && serviceObjData.padding_time > 0 ? MinutesToHours(serviceObjData.padding_time) : "";
          const durationWithPadding = serviceObjData && serviceObjData && serviceObjData.padding_time ? MinutesToHours(parseInt(serviceObjData.padding_time) + parseInt(serviceObjData.duration)) : (serviceObjData && serviceObjData.duration ? MinutesToHours(serviceObjData.duration) : "")

          const obj = {
            id: 1,
            category_id: bookingLinkData.category_id,
            service_id: bookingLinkData.service_id,
            staff_id: bookingLinkData.staff_id,
            serviceObjData: serviceObjData,
            staffObjData: staffObjData,
            datetime: "",
            totalprice: totalpricewithoutaddon,
            // datetime: availebleTimeObj.parentAppointmentEndTime,
            duration,
            padding_time,
            durationWithPadding,
            parentAppointmentEndTime: "",
            resource_item_id: "",
            resource_name: "",
          }

          // dispatch(BookingSelectedServicesData({ id: 1, category_id: bookingLinkData.category_id, service_id: bookingLinkData.service_id, staff_id: bookingLinkData.staff_id, serviceObjData: serviceObjData, staffObjData: staffObjData, datetime: "", totalprice: totalpricewithoutaddon }));
          dispatch(BookingSelectedServicesData(obj));
          // let page = 0;
          // if (bookingLinkData && bookingLinkData.category_id && bookingLinkData.service_id && bookingLinkData.staff_id) {
          //   page = 4;
          // } else if (bookingLinkData && bookingLinkData.category_id && bookingLinkData.service_id) {
          //   page = 3;
          // } else if (bookingLinkData && bookingLinkData.category_id) {
          //   page = 2;
          // }
          // dispatch(NextStep(page));
          let page = 0;
          if (bookingLinkData && bookingLinkData.category_id && bookingLinkData.service_id && bookingLinkData.staff_id) {
            page = 2;
          } else if (bookingLinkData && bookingLinkData.category_id && bookingLinkData.service_id) {
            page = 2;
          } else if (bookingLinkData && bookingLinkData.category_id) {
            page = 2;
          }else {
            page = 1;
          }
          dispatch(NextStep(page-1));
        }
      } else if (action.meta.requestStatus === "rejected") {
        const status = action.payload && action.payload.status;
        const errors = action.payload && action.payload.message && action.payload.message.errors;
        const response = action.payload && action.payload.message && action.payload.message;
        if (status === 422) {
          dispatch(
            OpenCustomAlerts({
              isOpen: "open",
              errors: (
                <>
                  <p className="mb-2 text-danger salert text-justify">{response && response.message}</p>
                  <ul className="list-unstyled">
                    {errors &&
                      Object.keys(errors).map((a, n) => {
                        if (errors[a].length > 0) {
                          return (
                            <>
                              {errors[a].map((as, ns) => {
                                return (
                                  <li key={n + "-" + ns} className="text-danger salert form-text text-start">
                                    {as}
                                  </li>
                                );
                              })}
                            </>
                          );
                        }
                      })}
                  </ul>
                </>
              )
            })
          );
        }
      }
    });
    // dispatch(NextStep(5));
  }, []);
  const override = css`
  display:block;
  `;
  return (
    <>
      {bookingApiStatus && bookingApiStatus.BookingApi === "succeeded" && isBookingApi ? (
        <div className="acsetup-left">
          <div className="container overflow-auto">
              <BookingSteps />
              {isBookingResourceModal && <BookingResourceModals />}
              {isBookingNextAvailableModal && <NextAvailableBookingModal />}
            <div className="power-be mt-3 text-center">
              <p>
                {t("Powered by")}
                <a className="ms-1" style={{ textDecoration: 'none' }}>
                  <b> Beauti Software</b>
                </a>
              </p>
            </div>
          </div>
        </div>
      ) : (
        <>{bookingApiStatus && bookingApiStatus.BookingApi === "loading" ? <ApiStatus actionType="bookingview" /> : ""}</>
      )}
      {isOpenCustomAlerts && <CustomAlerts />}
    </>
  );
};

export default OnlineBooking;
